import { useMemo } from 'react';

import { integrationsApi } from 'apis/integrations';

import { customCardIntegrations } from '../../../../utils/useIntegrations/integrations';
import { IntegrationsCardItem } from '../../card/integrationsCard';

type UseCustomCardsRepsonse = {
  isLoading: boolean;
  isError: boolean;
  customCards: IntegrationsCardItem[];
};
const emptyArray: IntegrationsCardItem[] = [];

/** A hook that returns all custom cards. */
export const useCustomCards = (): UseCustomCardsRepsonse => {
  const { data, isFetching, isError } =
    integrationsApi.useReadCustomCardIntegrationsQuery();

  return {
    isLoading: isFetching,
    customCards: useMemo(
      () =>
        data?.data.custom_cards.map(
          (card) =>
            ({
              cardType: card.integration_type,
              integrationType: 'customCard',
              integrationId: customCardIntegrations[card.integration_type].id,
              description:
                customCardIntegrations[card.integration_type].description,
              id: card.id,
              label: card.title,
            } as IntegrationsCardItem),
        ) || emptyArray,
      [data],
    ),
    isError,
  };
};
